import * as constants from './constants';

const defaultState = {
    spaceList: {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.SPACE_LIST:
            return {...state, spaceList: action.value}
        default:
            return state;
    }
}